import { createContext, ReactNode, useContext } from 'react'

type ModalContextType = {
  insideModal: boolean
}

const ModalContext = createContext({ insideModal: false } as ModalContextType)

interface ModalProviderProps {
  children: ReactNode
}

export const ModalProvider = ({ children }: ModalProviderProps) => {
  return <ModalContext.Provider value={{ insideModal: true }}>{children}</ModalContext.Provider>
}

export const useModalContext = () => {
  return useContext(ModalContext)
}
